import { model, Schema } from 'mongoose';
import { generateId } from '../services/utils.service';
import { type MongooseCheckedSchema } from './utils/model-document';

export interface TaskNumber {
  _id: string;
  orgId: string;
  spaceId: string;
  taskNumber: number;
}

const checkedSchema: MongooseCheckedSchema<TaskNumber> = {
  _id: { type: String, required: true, default: generateId },
  orgId: { type: String, required: true },
  spaceId: { type: String, required: true },
  taskNumber: { type: Number, required: true },
};

const schema = new Schema<TaskNumber>(checkedSchema);

schema.index({ orgId: 1, spaceId: 1 }, { unique: true });

export const TaskNumberModel = model<TaskNumber>('TaskNumber', schema);
